import { object, string } from 'yup';

import {
  I18N_TAX_FORMS_PATH,
  paymentMethodFormSchema,
  personalInfoFormSchema,
  TAX_FORM_STEP,
} from 'features/team/components/TaxEntryForm/constants';
import { TAX_ENTRY_PAYMENT_METHOD_PATH } from 'features/team/constants';

import { isInUS } from 'components/forms/TextField/util';

import { toI18n } from 'util/i18n';

const INITIAL_STATE_VALUE = '';

const taxFormInitialValues = (userData, step) => {
  const form = userData.employee_forms.find(f => f.description === step);

  if (form) {
    return form.parameters.reduce((memo, field) => {
      memo[field.name] = field.value || '';
      return memo;
    }, {});
  }

  return {};
};

export const initialValues = (userData, step) => {
  switch (step) {
    case TAX_FORM_STEP.PERSONAL_INFORMATION:
      return {
        legal_first_name: userData.first_name,
        legal_last_name: userData.last_name || '',
        city: '',
        zip_code: '',
        address_1: '',
        date_of_birth: '',
        ssn: '',
        ein: '',
        contractor_info_business_name: '',
        state: INITIAL_STATE_VALUE,
        tax_classification: userData.tax_classification,
        contractor_type: userData.contractor_type,
        is_in_us: isInUS(),
      };
    case TAX_FORM_STEP.PAYMENT_METHOD:
      return {
        payment_method: toI18n(
          `${TAX_ENTRY_PAYMENT_METHOD_PATH}.direct_deposit`
        ),
        decrypted_account_number: '',
        decrypted_reentered_account_number: '',
        decrypted_routing_number: '',
        bank_account_type: '',
      };
    default:
      return taxFormInitialValues(userData, step);
  }
};

function createYupSchema(schema, { name, depends_on, required }) {
  if (required) {
    if (depends_on) {
      schema[name] = string().when(depends_on.name, {
        is: depends_on.value_matches,
        then: string().required(
          toI18n(`${I18N_TAX_FORMS_PATH}.required_error`)
        ),
      });
    } else {
      schema[name] = string().required(
        toI18n(`${I18N_TAX_FORMS_PATH}.required_error`)
      );
    }
  }

  return schema;
}

const taxFormSchema = (userData, step) => {
  const form = userData.employee_forms.find(f => f.description === step);

  if (form) {
    return form.parameters.reduce(createYupSchema, {});
  }

  return {};
};

export const validationSchema = (userData, step) => {
  switch (step) {
    case TAX_FORM_STEP.PERSONAL_INFORMATION:
      return object().shape(personalInfoFormSchema());
    case TAX_FORM_STEP.PAYMENT_METHOD:
      return object().shape(paymentMethodFormSchema());
    default:
      return object().shape(taxFormSchema(userData, step));
  }
};

export const CHECK_ADDRESS_ERROR = {
  transformation_regex: /\s+/g,
  default_separator: '_',
  default_split_key: ': ',
  messages: {
    default: 'Invalid address',
    invalidAddress: 'invalid_address',
    incorrectCity: 'incorrect_city',
    incorrectState: 'incorrect_state',
    incorrectPostalCode: 'incorrect_postal_code',
    unknownStreet: 'unknown_street',
  },
};
